import { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import * as mb from "views/common/MessageBox";
import { useHistory } from "react-router-dom";
import { IFOrder } from "views/utils/CommonConst";
import { getRef, getRefSelect, getRefTextArea, setRef, setRefSelect, setRefTextArea } from "../../../utils/InputHelp";
import * as Validation from "../../../utils/Validation";
import { reloadBlock, scrollTop, sendWindowHeight } from "views/utils/CommonFunc";
import { CtxOrder } from "views/utils/Contexts";
import React from "react";
import { Error } from "views/guest/pages/error/Error";

export function GuestInfo(): JSX.Element{
    
    const history = useHistory();
    const order = useContext(CtxOrder);
    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const orderNameLast = useRef<HTMLInputElement>(null);
    const orderNameFirst = useRef<HTMLInputElement>(null);
    const furiganaLast = useRef<HTMLInputElement>(null);
    const furiganaFirst = useRef<HTMLInputElement>(null);
    const zip = useRef<HTMLInputElement>(null);
    const addressFirst = useRef<HTMLSelectElement>(null);
    const addressSecond = useRef<HTMLInputElement>(null);
    const addressThirs = useRef<HTMLInputElement>(null);
    const addressFourth = useRef<HTMLInputElement>(null);
    const phone = useRef<HTMLInputElement>(null);
    const emailAddress = useRef<HTMLInputElement>(null);
    const orderComment = useRef<HTMLTextAreaElement>(null);
    const [val, setVal] = React.useState('');
    const [serviceVal, setServiceVal] = React.useState('');
    const [loadErr, setLoadErr] = useState("");
    const refWindow = useRef<HTMLDivElement>(null);

    useEffect(function(){

        scrollTop();

        //カート画面を経由していない（ゲスト用セッションがない）場合、エラー
        if (!window.sessionStorage.getItem("guest_access_token")){
            setLoadErr("token_error");
            return;
        }

        //注文フォーム情報が使用開始していない場合（リロードされた場合）、エラー
        if (order.data.initial){
            setLoadErr("reload_error");
            return;
        }

        let tmpOrder:IFOrder = {...order.data};

        setRef(orderNameLast,order.data.order_name_last);
        setRef(orderNameFirst,order.data.order_name_first);
        setRef(furiganaLast,order.data.furigana_last);
        setRef(furiganaFirst,order.data.furigana_first);
        setRef(zip,order.data.zip);
        setRefSelect(addressFirst,order.data.address_first);
        setRef(addressSecond,order.data.address_second);
        setRef(addressThirs,order.data.address_thirs);
        setRef(addressFourth,order.data.address_fourth);
        setRef(phone,order.data.phone);
        setRef(emailAddress,order.data.email_address);
        //空の場合は一番上を初期値にする 
        if(order.data.parking_space_flg == ""){
            setVal("0");    
            tmpOrder.parking_space_flg = "0";
        }else{
            setVal(order.data.parking_space_flg);
        }
        //空の場合は一番上を初期値にする
        if(order.data.first_time_flg == ""){
            setServiceVal("0");
            tmpOrder.first_time_flg = "0";            
        }else{
            setServiceVal(order.data.first_time_flg);
        }
        setRefTextArea(orderComment,order.data.order_comment); 

        order.setData(tmpOrder);

        //ウィンドウサイズを呼び出し元に渡す
        sendWindowHeight(refWindow);
    
        //リロード制御
        window.addEventListener('beforeunload', reloadBlock);
        return function(){
            window.removeEventListener('beforeunload', reloadBlock);
        }

    }, []);
    
    //画面リサイズでウィンドウサイズを呼び出し元に渡す
    useLayoutEffect(function(){
        window.addEventListener('resize', resize);
        return () => window.removeEventListener('resize', resize);
    });
    function resize(){
        sendWindowHeight(refWindow);
    }


    //------------------------------------------------------------
    //注文フォーム情報のContextに値を設定する処理
    //------------------------------------------------------------
    function inputed(){

        let tmpOrder:IFOrder = {...order.data};

        tmpOrder.order_name_last = getRef(orderNameLast).replace(/\s/g, '');
        tmpOrder.order_name_first = getRef(orderNameFirst).replace(/\s/g, '');
        tmpOrder.furigana_last = getRef(furiganaLast).replace(/\s/g, '');
        tmpOrder.furigana_first = getRef(furiganaFirst).replace(/\s/g, '');
        tmpOrder.zip = getRef(zip);
        tmpOrder.address_first = getRefSelect(addressFirst);
        tmpOrder.address_second = getRef(addressSecond);
        tmpOrder.address_thirs = getRef(addressThirs);
        tmpOrder.address_fourth = getRef(addressFourth);
        tmpOrder.phone = getRef(phone);
        tmpOrder.email_address = getRef(emailAddress);
        tmpOrder.order_comment = getRefTextArea(orderComment);

        order.setData(tmpOrder);

    }

     //------------------------------------------------------------
    //駐車スペースの有無ラジオボタンチェック時の処理
    //------------------------------------------------------------
    function handleChange(e:any){
        setVal(e.target.value);
        let tmpOrder:IFOrder = {...order.data};
        tmpOrder.parking_space_flg = e.target.value;
        order.setData(tmpOrder);
    }

    //------------------------------------------------------------
    //弊社サービスのご利用についてラジオボタンチェック時の処理
    //------------------------------------------------------------
    function serviceHandleChange(e:any){
        setServiceVal(e.target.value);
        let tmpOrder:IFOrder = {...order.data};
        tmpOrder.first_time_flg = e.target.value;
        order.setData(tmpOrder);
    }

    function clickSubmit(){

        //バリデーションチェック
        let errmsg:string;

        //姓
        errmsg = Validation.checkEmptyTextBox(getRef(orderNameLast), "姓")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkLengthOver(getRef(orderNameLast), 20, "姓")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        //名
        errmsg = Validation.checkEmptyTextBox(getRef(orderNameFirst), "名")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkLengthOver(getRef(orderNameFirst), 20, "名")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        //せい（ふりがな）
        errmsg = Validation.checkEmptyTextBox(getRef(furiganaLast), "せい（ふりがな）")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkLengthOver(getRef(furiganaLast), 60, "せい（ふりがな）")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        //めい（ふりがな）
        errmsg = Validation.checkEmptyTextBox(getRef(furiganaFirst), "めい（ふりがな）")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkLengthOver(getRef(furiganaFirst), 60, "めい（ふりがな）")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        //郵便番号
        errmsg = Validation.checkEmptyTextBox(getRef(zip), "郵便番号")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkZipCodeRule(getRef(zip), "郵便番号")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        //都道府県
        errmsg = Validation.checkEmptyTextBox(getRefSelect(addressFirst), "都道府県")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        //市区町村
        errmsg = Validation.checkEmptyTextBox(getRef(addressSecond), "市区町村")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkLengthOver(getRef(addressSecond),48 , "市区町村")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        //町名・番地名
        errmsg = Validation.checkEmptyTextBox(getRef(addressThirs), "町名・番地名")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkLengthOver(getRef(addressThirs),48 , "町名・番地名")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        //建物名・号室
        errmsg = Validation.checkLengthOver(getRef(addressFourth), 100, "建物名・号室")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        //電話番号
        errmsg = Validation.checkEmptyTextBox(getRef(phone), "電話番号")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkTelNumberRule(getRef(phone), "電話番号")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        //メールアドレス
        errmsg = Validation.checkEmptyTextBox(getRef(emailAddress), "メールアドレス")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkLengthOver(getRef(emailAddress), 256, "メールアドレス")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkMailRule(getRef(emailAddress), "メールアドレス")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        //ご要望・ご質問等
        errmsg = Validation.checkLengthOver(getRefTextArea(orderComment), 1000, "ご要望・ご質問等")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        history.push("/guest/confirm");

    }
    
    if (loadErr){
        return (
            <Error type={loadErr}/>
        )
    } else {
        return (
            <div className="order-main" ref={refWindow}>
                <div className="order-width-max">
                    <div className="order-box">
                        <div className="order-flow">
                            <ul className="order-flow-list">
                                <li className="is-past">見積内容の選択</li>
                                <li className="is-past">希望日時の選択</li>
                                <li className="is-current">申込情報の入力</li>
                                <li>申込内容の確認</li>
                                <li>申込完了</li>
                            </ul>
                        </div>
                        <div className="order-form">
                            <div className="order-form-title">
                                お申込情報入力フォーム
                            </div>
                            <div className="form-row">
                                <div className="control-horizon">
                                    <div style={{width: "50%"}}>
                                        <div className="form-row-title">姓</div>
                                        <div className="form-row-input"><input type="text" ref={orderNameLast} onBlur={inputed}/></div>
                                    </div>
                                    <div style={{width: "50%"}}>
                                        <div className="form-row-title">名</div>
                                        <div className="form-row-input"><input type="text" ref={orderNameFirst} onBlur={inputed}/></div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="control-horizon">
                                    <div style={{width: "50%"}}>
                                        <div className="form-row-title">せい（ふりがな）</div>
                                        <div className="form-row-input"><input type="text" ref={furiganaLast} onBlur={inputed}/></div>
                                    </div>
                                    <div style={{width: "50%"}}>
                                        <div className="form-row-title">めい（ふりがな）</div>
                                        <div className="form-row-input"><input type="text" ref={furiganaFirst} onBlur={inputed}/></div>
                                    </div>
                                </div>
                            </div>
                            <form className="h-adr">
                                <span className="p-country-name" style={{display:"none"}}>Japan</span>
                                <div className="form-row">
                                    <div className="form-row-title">郵便番号</div>
                                    <div className="form-row-comment">
                                        ハイフンをつけて入力してください。
                                    </div>
                                    <div className="form-row-input form-row-postcode">
                                        <input type="text" className="input-size-s p-postal-code" placeholder="000-0000" ref={zip} onBlur={inputed}/>
                                        <button className="btn-tertiary btn-icon-left" style={{display:"none"}}><span className="icon material-icons-round">search</span>郵便番号から住所を入力</button>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-row-title">都道府県</div>
                                    <div className="form-row-input">
                                        <div className="select input-size-s">
                                            <select id="addressFirst" ref={addressFirst} onBlur={inputed} className="p-region">
                                            <option value=""></option>
                                            <option value="北海道">北海道</option>
                                            <option value="青森県">青森県</option>
                                            <option value="岩手県">岩手県</option>
                                            <option value="宮城県">宮城県</option>
                                            <option value="秋田県">秋田県</option>
                                            <option value="山形県">山形県</option>
                                            <option value="福島県">福島県</option>
                                            <option value="茨城県">茨城県</option>
                                            <option value="栃木県">栃木県</option>
                                            <option value="群馬県">群馬県</option>
                                            <option value="埼玉県">埼玉県</option>
                                            <option value="千葉県">千葉県</option>
                                            <option value="東京都">東京都</option>
                                            <option value="神奈川県">神奈川県</option>
                                            <option value="新潟県">新潟県</option>
                                            <option value="富山県">富山県</option>
                                            <option value="石川県">石川県</option>
                                            <option value="福井県">福井県</option>
                                            <option value="山梨県">山梨県</option>
                                            <option value="長野県">長野県</option>
                                            <option value="岐阜県">岐阜県</option>
                                            <option value="静岡県">静岡県</option>
                                            <option value="愛知県">愛知県</option>
                                            <option value="三重県">三重県</option>
                                            <option value="滋賀県">滋賀県</option>
                                            <option value="京都府">京都府</option>
                                            <option value="大阪府">大阪府</option>
                                            <option value="兵庫県">兵庫県</option>
                                            <option value="奈良県">奈良県</option>
                                            <option value="和歌山県">和歌山県</option>
                                            <option value="鳥取県">鳥取県</option>
                                            <option value="島根県">島根県</option>
                                            <option value="岡山県">岡山県</option>
                                            <option value="広島県">広島県</option>
                                            <option value="山口県">山口県</option>
                                            <option value="徳島県">徳島県</option>
                                            <option value="香川県">香川県</option>
                                            <option value="愛媛県">愛媛県</option>
                                            <option value="高知県">高知県</option>
                                            <option value="福岡県">福岡県</option>
                                            <option value="佐賀県">佐賀県</option>
                                            <option value="長崎県">長崎県</option>
                                            <option value="熊本県">熊本県</option>
                                            <option value="大分県">大分県</option>
                                            <option value="宮崎県">宮崎県</option>
                                            <option value="鹿児島県">鹿児島県</option>
                                            <option value="沖縄県">沖縄県</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-row-title">市区町村</div>
                                    <div className="form-row-input"><input type="text" id="addressSecond" className="p-locality" ref={addressSecond} onBlur={inputed}/></div>
                                </div>
                                <div className="form-row">
                                    <div className="form-row-title">町名・番地</div>
                                    <div className="form-row-input"><input type="text" id="addressThirs" className="p-street-address p-extended-address" ref={addressThirs} onBlur={inputed}/></div>
                                </div>
                                <div className="form-row">
                                    <div className="form-row-title">建物名・号室</div>
                                    <div className="form-row-input"><input type="text" id="addressFourth" ref={addressFourth} onBlur={inputed}/></div>
                                </div>
                            </form>
                            <div className="form-row">
                                <div className="form-row-title">電話番号</div>
                                <div className="form-row-comment">
                                    ハイフンをつけて入力してください。
                                </div>
                                <div className="form-row-input">
                                    <input type="text" className="input-size-s" placeholder="000-0000-0000" ref={phone} onBlur={inputed}/>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-row-title">メールアドレス</div>
                                <div className="form-row-input"><input type="text" ref={emailAddress} onBlur={inputed}/></div>
                            </div>
                            <div className="form-row">
                                <div className="form-row-title">駐車スペースの有無</div>
                                <div className="form-row-input control-vertical">
                                    <label className="radio"><input type="radio" name="parking" value="0" checked={val === '0'} onChange={handleChange}/><div>あり</div></label>
                                    <label className="radio"><input type="radio" name="parking" value="1" checked={val === '1'} onChange={handleChange}/><div>近くに有料のパーキングあり</div></label>
                                    <label className="radio"><input type="radio" name="parking" value="2" checked={val === '2'} onChange={handleChange}/><div>なし</div></label>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-row-title">弊社サービスのご利用について</div>
                                <div className="form-row-input control-vertical">
                                    <label className="radio"><input type="radio" name="service" value="0" checked={serviceVal === '0'} onChange={serviceHandleChange}/><div>はじめて</div></label>
                                    <label className="radio"><input type="radio" name="service" value="1" checked={serviceVal === '1'} onChange={serviceHandleChange}/><div>2回目以降</div></label>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-row-title">ご要望・ご質問等</div>
                                <div className="form-row-input"><textarea ref={orderComment} onBlur={inputed} style={{height: "200px"}} placeholder="家電のクリーニングをご依頼の方は、メーカーや機器名等をご記入ください。"></textarea></div>
                            </div>
                            <mb.MessageBox args={msgArgs}/>
                        </div>
                        <div className="form-row control-horizon control-between">
                            <button className="btn-order btn-secondary btn-icon-left" onClick={function(){history.push("/guest/reservation")}}><span className="icon material-icons-round md-18">arrow_back</span>希望日時の選択に戻る</button>
                            <button className="btn-order btn-primary btn-icon-right" onClick={clickSubmit}>申込内容の確認へ進む<span className="icon material-icons-round md-18">arrow_forward</span></button>
                        </div>
                    </div>
                </div>
            </div>
            
        )
    }
}